// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"133":"4818ffb9","150":"eeac7ba4","332":"3f376a42","530":"9c9f99f1","820":"3858dddc"}[chunkId] + ".chunk.css";
};